// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3zLP7","content":"styles_content__1In1x","selectAll":"styles_selectAll__1ox-4"};